const prefix = '  0SECTION  2HEADER';

const parseDxfHeader = (buffer) => {
	let text = new TextDecoder().decode( buffer );
	// remove line breaks
	text = text.replaceAll(/(\r\n|\n|\r)/gm, '');
	
	return text.indexOf( prefix ) >= 0;
};

const dxf = async (reader) => {
	const buffer = await reader.read(0, 1024);
	return parseDxfHeader( buffer );
}

export {
	dxf
}